module.exports = __webpack_public_path__ + "static/media/Home4.adc93f59.mp4";